export default "__VITE_ASSET__Dbstd1RO__"